(function () {
  if (window.__preorderSyncing) return;
  window.__preorderSyncing = new Set();

  class CartPreorderSync extends HTMLElement {
    connectedCallback() {
      if (this.dataset.started === 'true') return;
      this.dataset.started = 'true';

      var script = this.querySelector('script[type="application/json"]');
      if (!script) return;

      var lines = [];
      try {
        lines = JSON.parse(script.textContent || '[]');
      } catch (error) {
        return;
      }

      var pending = [];
      lines.forEach(function (line) {
        if (!line || !line.key || !line.note) return;
        var token = line.key + '\n' + line.note;
        if (window.__preorderSyncing.has(token)) return;
        window.__preorderSyncing.add(token);
        pending.push(line);
      });

      if (!pending.length) return;

      var routes = (window.themeVariables && window.themeVariables.routes) || {};
      var changeUrl = (routes.cartChangeUrl || '/cart/change') + '.js';
      var task = pending.reduce(function (chain, line) {
        return chain.then(function () {
          var properties = Object.assign({}, line.properties || {});
          properties['PreOrder-Note'] = line.note;
          return fetch(changeUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: line.key,
              quantity: line.quantity,
              properties: properties,
              sections: 'mini-cart'
            })
          }).then(function (response) {
            return response.json();
          });
        });
      }, Promise.resolve());

      window.__preorderSyncPromise = task.then(function (cart) {
        if (!cart || cart.status) return;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: cart,
            openMiniCart: false
          }
        }));
      }).catch(function () {
        pending.forEach(function (line) {
          window.__preorderSyncing.delete(line.key + '\n' + line.note);
        });
      });
    }
  }

  if (!customElements.get('cart-preorder-sync')) {
    customElements.define('cart-preorder-sync', CartPreorderSync);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.dataset.preorderReady === 'true') return;
    if (!form.action || form.action.indexOf('/cart') === -1) return;
    var submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    if (!window.__preorderSyncPromise) return;

    event.preventDefault();
    window.__preorderSyncPromise.finally(function () {
      form.dataset.preorderReady = 'true';
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter);
      } else {
        submitter.click();
      }
    });
  });
})();
